
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Button from "@insite/mobius/Button";
import Page from "@insite/mobius/Page";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
export interface UnhandledErrorModalStyles {
secondary?:InjectableCss
}


export const unhandledError:UnhandledErrorModalStyles={
 secondary:{
    css:css`
    align-items:center;
     margin:0px 100px 0px 300px;
     display: grid;
  place-items: center;

    `
 }
}



const styles=unhandledError;


const UnhandledErrorModal = ({
    id,
    fields,
    shellContext: { isCurrentPage, isInShell },
    
}: PageProps & HasShellContext) => {
    const onContinue=()=>{
       window.location.reload();
    }
    
 return(
    
    <Page >
        {isCurrentPage && isInShell && (
            // we can't use the PageTitle widget because it will always show the title of the current page. That would work in the shell, but not when the modal displays in the real world
            <Typography variant="h2" as="h1">
               {siteMessage("ErrorOccurred")}
            </Typography>
        )}

        <Button {...styles.secondary} onClick={onContinue}>
                    {translate("Continue")}
                </Button>
    </Page>
    
)};

const pageModule: PageModule = {
    component: withIsInShell(UnhandledErrorModal),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                name: "modalTitle",
                displayName: "Modal Title",
                editorTemplate: "TextField",
                defaultValue: "An unhandled error has occurred, please press continue to refresh your page.",
                fieldType: "Translatable",
                isRequired: true,
                sortOrder: 0,
            },
        ],
    },
};

export default pageModule;
